module.exports = __webpack_public_path__ + "img/community-banner.48235401.png";